import { useState as m, useMemo as f } from "react";
import p from "../services/ApiService.js";
import { useSelector as d, useDispatch as h } from "react-redux";
import S from "./useUserAccounts.js";
import { setUser as w } from "../services/DataStoreService/reducers/AppReducer.js";
function U() {
  const { user: t } = d((e) => e.app.datastate), { accounts: r } = S(), n = h(), [o, i] = m(!1), a = f(() => t && t._id && t.currentSession ? [
    ...(r || []).map((e) => ({
      name: c(e),
      email: e.email,
      id: e._id
    }))
  ] : [], [t.currentSession, r]);
  function c(e) {
    return e.members != null ? e.facilityName : e.firstName != null || e.lastName != null ? [e.firstName, e.lastName].filter(Boolean).join(" ") : null;
  }
  const u = t.currentSession;
  async function l(e) {
    try {
      i(!0);
      const { data: s } = await p(t.userToken).PatchUser({
        patchType: "switchAccount",
        userId: t._id,
        accountId: e,
        user: t
      });
      n(w(s.payload));
    } catch (s) {
      console.log(s);
    } finally {
      i(!1);
    }
  }
  return {
    profiles: a,
    selectedProfileId: u,
    switchAccount: l,
    isSwitching: o
  };
}
export {
  U as default
};
